import React from 'react';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import styles from 'feature/brandTabs/pricingAndSuppliers/styles.module.scss';
import { Button, Col, EditableInfoComponent, Row, Typography } from 'components';
import { EditIcon, ManagementIcon, RemoveIcon, TableEmptyIcon } from 'components/common/icons';
import { useMainSupplier } from 'feature/brandTabs/pricingAndSuppliers/mainSupplier/useMainSupplier';
import { MainSupplierRemoveModal } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid/mainSupplierRemoveModal';
import { PriceReferenceSupplierModal } from 'feature/brandTabs/pricingAndSuppliers/mainSupplier/priceRefrenceSupplier/edit';
import { PriceReferenceSupplierRemoveModel } from 'feature/brandTabs/pricingAndSuppliers/mainSupplier/priceRefrenceSupplier/remove';

const { Text } = Typography;
export const MainSupplier = React.memo(() => {
  const {
    mainSupplier,
    pricingReferenceSupplier,
    mainSupplierRemoveModalState,
    onMainRemoveModalStateChange,
    onPriceReferenceSupplierModalStateChange,
    priceReferenceSupplierModalState,
    priceReferenceSupplierRemoveModalState,
    onPriceReferenceSupplierRemoveModalStateChange,
    onRedirectToSupplier,
  } = useMainSupplier();
  return (
    <>
      {mainSupplier && <EditableInfoComponent editable={false} title={'Main Supplier'} icon={<ManagementIcon />} />}
      <Row gutter={[0, 16]}>
        {mainSupplier && (
          <Col span={24}>
            <Row gutter={[0, 6]}>
              <Col span={24}>
                <Row align={'middle'} justify={'space-between'}>
                  <Button
                    className={styles.main_supplier_name}
                    variant={'text'}
                    type={'text'}
                    size={'small'}
                    style={{ background: 'transparent' }}
                    onClick={() => onRedirectToSupplier(mainSupplier.id)}
                  >
                    {mainSupplier.name}
                  </Button>
                  <HasAccess role={PERMISSIONS.brands.main_supplier.write}>
                    <Button
                      onClick={onMainRemoveModalStateChange}
                      style={{ padding: 0, width: 16, height: 16 }}
                      type={'text'}
                      size={'small'}
                      icon={<RemoveIcon />}
                    ></Button>
                  </HasAccess>
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 4]}>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Margin</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.markup !== null ? `${mainSupplier.markup}%` : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Average Margin</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.averageMargin !== null ? `${mainSupplier.averageMargin}%` : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Lead Time</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.averageLeadTime !== null
                            ? `${mainSupplier.averageLeadTime} ${mainSupplier.averageLeadTime > 1 ? `${mainSupplier.timeUnit?.toLowerCase()}s` : mainSupplier.timeUnit?.toLowerCase()}`
                            : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Deals Count</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.dealsCount !== null ? `${mainSupplier.dealsCount}` : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Deals Amount</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.dealsAmount !== null ? `${mainSupplier.dealsAmount}$` : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row justify={'space-between'} align={'middle'}>
                      <Col>
                        <Text type={'secondary'}>Price List Updated</Text>
                      </Col>
                      <Col>
                        <Text type={'secondary'}>
                          {mainSupplier.formattedPriceListUpdatedDate?.day
                            ? `${mainSupplier.formattedPriceListUpdatedDate.day}`
                            : 'Not Set'}
                        </Text>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        )}
        <Col span={24}>
          <Row align={'middle'} justify={'space-between'} wrap={false}>
            <Col>
              <Text>Price Reference Supplier: </Text>
              {pricingReferenceSupplier ? (
                <Button
                  className={styles.reference_supplier_name}
                  variant={'text'}
                  type={'text'}
                  size={'small'}
                  style={{
                    background: 'transparent',
                  }}
                  onClick={() => onRedirectToSupplier(pricingReferenceSupplier.id)}
                >
                  {pricingReferenceSupplier.name}
                </Button>
              ) : (
                'Not Set'
              )}
            </Col>
            <Col>
              <Row align={'middle'} className={'gap-2'} wrap={false}>
                <HasAccess role={PERMISSIONS.brands.main_supplier.write}>
                  <Button
                    onClick={onPriceReferenceSupplierModalStateChange}
                    style={{ padding: 0, width: 16, height: 16 }}
                    size={'small'}
                    type={'text'}
                    icon={<EditIcon />}
                  />
                </HasAccess>
                <HasAccess role={PERMISSIONS.brands.main_supplier.write}>
                  {pricingReferenceSupplier && (
                    <Button
                      onClick={onPriceReferenceSupplierRemoveModalStateChange}
                      style={{ padding: 0, width: 16, height: 16 }}
                      size={'small'}
                      type={'text'}
                      icon={<RemoveIcon />}
                    />
                  )}
                </HasAccess>
              </Row>
            </Col>
          </Row>
        </Col>
        {!mainSupplier && (
          <Col span={24} style={{ marginTop: 20 }}>
            <Row gutter={[0, 12]} justify={'center'}>
              <TableEmptyIcon />
              <Col span={24} className={'center'}>
                <Text type={'secondary'}>No main supplier assigned</Text>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <MainSupplierRemoveModal
        modalState={mainSupplierRemoveModalState}
        onModalStateChange={onMainRemoveModalStateChange}
      />
      <PriceReferenceSupplierModal
        modalState={priceReferenceSupplierModalState}
        onModalStateChange={onPriceReferenceSupplierModalStateChange}
        dataToEdit={pricingReferenceSupplier}
      />
      <PriceReferenceSupplierRemoveModel
        modalState={priceReferenceSupplierRemoveModalState}
        onModalStateChange={onPriceReferenceSupplierRemoveModalStateChange}
      />
    </>
  );
});
